var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.signedIn())?_c('div',{staticClass:"navbar"},[_c('a',{staticClass:"navbar-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.signOut($event)}}},[_vm._v("Sign out")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }